import ServerApi from "./../../libs/api-services/server-api"

class ChatService extends ServerApi {
  URL_PREFIX = "/v1/secure/user/maps/"

  async loadChat(chatId) {
    return await this.get(`/v1/secure/user/chat/${chatId}`)
  }

  async sendChat(chatId, message) {
    return await this.post(`/v1/secure/user/chat/${chatId}`, {message})
  }
}

export const chatService = new ChatService()
